import { canUseDOM, getBaseUrl, getCurrentURL } from '@common/utils'

export const Routes = {
  cart: '/cart',
  checkout: '/checkout',
  deviceDiagnostic: '/device-diagnostic',
  emailVerification: '/EmailVerification',
  invitationTrackNFC: '/invitation/track/on/nfc_dev_reg',
  lineRegisterThankyou: '/line/register-thankyou',
  main: '/',
  orderConfirmation: '/OrderConfirmation',
  products: '/products',
  profile: '/profile',
  profileAccount: '/profile#account',
  profileDevices: '/profile#devices',
  register: '/register',
  registerSuccess: '/register/success',
  shopCatalogue: '/shop/catalogue',
  smartSelection: '/shop/catalogue/promotion/smart-selection',
  supportReplace: '/support/replace',
  userLogin: '/user-login',
  upgradeCheckout: '/upgrade-checkout',
  upgradeOffer: '/upgrade-offer',
  upgradeOfferCart: '/upgrade-offer/cart',
  upgradeOfferCheckout: '/upgrade-offer/checkout'
}

export const Fragments = {
  delivery: 'delivery',
  account: 'account'
}

export const Name = {
  blank: '_blank'
}

export const Specs = {
  noOpener: 'noopener',
  noReferrer: 'noreferrer'
}

export function getDynamicPath(path, value, divider = '/') {
  return path + divider + value
}

export function getRoute(
  mainPath,
  isBaseURL = false,
  isCurrentUrl = false,
  params = null,
  fragment = null
) {
  let url = mainPath

  if (mainPath && isCurrentUrl) {
    const param = params !== null ? params : ''
    url = mainPath + '?' + getCurrentURL(param)
  }

  if (isBaseURL && mainPath) {
    url = getBaseUrl() + mainPath
  }

  if (mainPath && params && params.length > 0 && !isCurrentUrl) {
    url = mainPath + '?' + params.join('&')
  }

  if (isBaseURL && mainPath && params && params.length > 0) {
    url = getBaseUrl() + mainPath + '?' + params.join('&')
  }

  if (
    isBaseURL &&
    mainPath &&
    params &&
    params.length > 0 &&
    fragment !== null
  ) {
    url = getBaseUrl() + mainPath + '?' + params.join('&') + '#' + fragment
  }

  return url
}

export function goTo(
  mainPath,
  isBaseURL = false,
  isCurrentUrl = false,
  params = null,
  fragment = null
) {
  if (canUseDOM) {
    window.location.href = getRoute(
      mainPath,
      isBaseURL,
      isCurrentUrl,
      params,
      fragment
    )
  }
}

export function open(path, name = Name.blank, specs = null) {
  const specsList = specs && specs.length > 0 && specs.join(',')
  canUseDOM && window.open(path, name, specsList)
}
